import { Address } from "@opendaw/lib-box";
import { assert } from "@opendaw/lib-std";
import { AutomatableParameterFieldAdapter } from "./AutomatableParameterFieldAdapter";
export class ParameterAdapterSet {
    #context;
    #parameters;
    constructor(context) {
        this.#context = context;
        this.#parameters = Address.newSet(adapter => adapter.address);
    }
    terminate() {
        this.#parameters.forEach(parameter => parameter.terminate());
        this.#parameters.clear();
    }
    parameters() { return this.#parameters.values(); }
    parameterAt(address) {
        return this.#parameters.getOrThrow(address, () => new Error(`No ParameterAdapter found at [${address.toString()}]`));
    }
    createParameter(field, valueMapping, stringMapping, name, anchor) {
        const adapter = new AutomatableParameterFieldAdapter(this.#context, field, valueMapping, stringMapping, name, anchor);
        const added = this.#parameters.add(adapter);
        assert(added, `Could not add adapter for ${field}`);
        return adapter;
    }
    removeParameter(address) {
        return this.#parameters.removeByKey(address);
    }
}
